import { NumberPicker } from '@alifd/next';
import wrapper from './next-wrapper';
const FormNumberInput = wrapper(NumberPicker, 'CbayelFormNumberInput');
export default FormNumberInput;
